<app-slide [margin]="20" [elementWidth]="300">
    <app-card-logotipo class="flex-30" *ngFor="let logo of logos" urlImage="{{logo.url_image}}"
        title="{{logo.title | translate}}" [background]="logo.background"
        urlDownloadImagesPng="{{logo.url_download_images_png}}" urlDownloadImagesSvg="{{logo.url_download_images_svg}}">
    </app-card-logotipo>
    <mat-card class="download-logo-container flex-30">
        <mat-card-content></mat-card-content>
        <mat-card-content class="material-institucional-container">
            <p [innerHTML]="'file_one' | translate"></p>
        </mat-card-content>
        <mat-card-content>
            <a mat-button title="{{ 'file_one' | translate }}"
                href="assets/images/press/manual-de-marca-saldo-ar-v1.pdf" download>
                <span class="material-icons-outlined">file_download</span>
                PDF
            </a>
        </mat-card-content>
    </mat-card>
    <mat-card class="download-logo-container flex-30">
        <mat-card-content></mat-card-content>
        <mat-card-content class="material-institucional-container">
            <p [innerHTML]="'file_two' | translate"></p>
        </mat-card-content>
        <mat-card-content>
            <a mat-button title="{{ 'file_two' | translate }}" href="assets/images/press/gacetilla-de-prensa.pdf"
                download>
                <span class="material-icons-outlined">file_download</span>
                PDF
            </a>
        </mat-card-content>
    </mat-card>
</app-slide>
